import { DTIProps } from '@xometry/ui';
import cn from 'clsx';
import { FC, PropsWithChildren } from 'react';

import styles from './ContentWrapper.module.less';

interface ContentWrapperProps extends Partial<DTIProps> {
  containerClassName?: string;
}
const ContentWrapper: FC<PropsWithChildren<ContentWrapperProps>> = ({ children, containerClassName, ...rest }) => {
  return (
    <div {...rest} className={cn(containerClassName, styles.container)}>
      {children}
    </div>
  );
};

export default ContentWrapper;
